import { INominationsResponce, INominee, NominationsT } from '../../../model/types';

interface IGetCurrentNominationNominees {
  $pollItems: INominationsResponce[];
  $currentNominationName: NominationsT | null;
}

export const getCurrentNominationNominees = (
  { $pollItems, $currentNominationName }: IGetCurrentNominationNominees
): INominee[] => $pollItems.find(item => item.name === $currentNominationName)?.nominees ?? [];
